import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next'
import {PrismicRichText} from '@prismicio/react'
import {FourGridSliceCards} from 'prismicio-types'
import {Container} from 'src/common/Container'
import {LinkWrapper} from 'src/common/LinkWrapper'

type FourGridCardsProps = {
  slice: FourGridSliceCards & {
    slice_type: string
    variation: string
  }
  pageUid: string
  componentIndex: number
}

export const CardsVariation = ({slice, pageUid, componentIndex}: FourGridCardsProps) => {
  return (
    <Container
      backgroundColor={slice.primary.background_color}
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="justify-center !py-10 px-5 md:!py-20 md:px-10 lg:px-5 xl:px-0"
    >
      <div className="flex w-full max-w-[1200px] flex-col gap-10 lg:gap-12" data-aos="fade-up">
        <div className="flex flex-col gap-4 lg:gap-6">
          <span className="text-button-s text-ui-blue-450">{slice.primary.tag}</span>
          <PrismicRichText
            field={slice.primary.title}
            components={{
              heading2: ({children}) => (
                <h3 className="lg:text-tg-h2 text-32 leading-[normal] tracking-[-.32px] text-moss-black">{children}</h3>
              ),
              strong: ({children}) => <span className="text-moss-grey-400">{children}</span>,
            }}
          />
        </div>
        <div className="grid grid-cols-1 gap-6 min-[500px]:grid-cols-2 md:flex-row md:flex-wrap lg:grid-cols-4 lg:flex-nowrap">
          {slice.primary.cards.map((card, index) => (
            <LinkWrapper
              key={`card-link-${index}`}
              link={card.link}
              mktgId="four-grid-card"
              location={`component-${componentIndex}-card-${index}`}
              pageName={pageUid}
              dataType={`card-${index}`}
              className="group/card"
            >
              <div className="flex w-full flex-col gap-3 rounded-lg bg-moss-white p-4 lg:gap-4 lg:p-6">
                <picture>
                  {isFilled.imageThumbnail(card.image.mobile) && (
                    <source
                      media="(max-width: 1024px)"
                      srcSet={card.image.mobile.url + '?auto=compress,format&fit=max&w=768'}
                      sizes="50vw"
                    />
                  )}
                  <PrismicNextImage
                    field={card.image}
                    className="aspect-[141/100] w-full rounded-[6px] object-cover md:aspect-[141/100] lg:aspect-square"
                  />
                </picture>
                <div className="flex w-full justify-between">
                  <div className="flex flex-col gap-1.5">
                    <p className="text-18 font-medium leading-6 text-moss-black">{card.title}</p>
                    <span className="text-button-s text-moss-black/[60%]">{card.subtitle}</span>
                  </div>
                  <PrismicNextImage
                    field={card.icon}
                    className="h-6 w-6 min-w-6 self-end overflow-hidden transition-all duration-300 ease-in-out group-hover/card:brightness-[1.15]"
                  />
                </div>
              </div>
            </LinkWrapper>
          ))}
        </div>
      </div>
    </Container>
  )
}
